export const urls = {
  getStripeProducts:
    "https://xxgkqnya5qzrlsasl2s47rg3nm0sxrgb.lambda-url.ap-southeast-1.on.aws/",
  pricings: "/pricings",
  login: "/login",
  account: "/accounts",
};
